var CourseModuleService = function() {
  this.saveModuleProgress = function(view, page, mod){
    this.saveModule(mod);
    view.render();
  };

  this.saveModule = function(mod){
    mod.save();
  };
};

module.exports = new CourseModuleService();